/**
 * 获取指定 Cookie 值
 * @param {String} k 指定的 Cookie 名
 */
export const getCookie = (k) => {
  const res = RegExp('(^|; )' + encodeURIComponent(k) + '=([^;]*)').exec(document.cookie)
  return res && res[2]
}

export function setCookie(name, value, expriesDays, encode = false) {
  var Days = expriesDays || 20
  var exp = new Date()
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000)
  // 测试用，cookie有效期2分钟
  // exp.setTime(exp.getTime() + 2*60*1000)
  const val = encode ? escape(value) : value
  document.cookie = name + '=' + val + ';domain=zhuanzhuan.com;path=/;expires=' + exp.toGMTString()
}
